import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { AngularSvgIconModule } from 'angular-svg-icon';

export type IconType = 'default' | 'success' | 'warning' | 'error';

@Component({
	changeDetection: ChangeDetectionStrategy.OnPush,
	selector: `vp-status-header`,
	templateUrl: './status-header.html',
	imports: [AngularSvgIconModule, NgClass],
})
export class StatusHeaderComponent {
	icon = input<string>('');
	iconAnimationClass = input<string>('');
	iconType = input<IconType>('default');
	ariaLabel = input<string>('');
	className = input<string>('');
}
